import { Timestamp } from "firebase/firestore";

export const classToFirestore = (formData, weekday, idTenant, authUser, lookups = {}) => {
    const { activities = [], employees = [], areas = [] } = lookups;

    const activity = activities.find(a => a.id === formData.idActivity) || {};
    const employeeLookup = employees.find(e => e.id === formData.idEmployee);
    const isSelf = authUser && (formData.idEmployee === authUser.uid || formData.idEmployee === authUser.id);
    const employeeName = employeeLookup?.fullName || employeeLookup?.name || (isSelf ? (authUser.displayName || authUser.fullName || authUser.name) : "");
    const employeePhone = employeeLookup?.phone || (isSelf ? authUser.phone : undefined);
    const employeeEmail = employeeLookup?.email || (isSelf ? authUser.email : undefined);
    const employeePhotoUrl = employeeLookup?.photoUrl || (isSelf ? authUser.photoURL : undefined);

    const area = areas.find(a => a.id === formData.idArea) || {};

    const payload = {
        idTenant,
        idActivity: formData.idActivity,
        idEmployee: formData.idEmployee,
        idArea: formData.idArea,
        classGroupId: formData.classGroupId,

        // Dados desnormalizados (essencial para TV/Listas sem múltiplos joins)
        activityName: activity.name,
        activityColor: activity.color,
        evaluationSystem: activity.evaluationSystem === true,
        employeeName: employeeName.trim(),
        employeePhone: employeePhone,
        employeeEmail: employeeEmail,
        employeePhotoUrl: employeePhotoUrl,
        areaName: area.name,

        weekday: Number(weekday), // 0=Dom, 1=Seg...
        startTime: formData.startTime,
        durationMinutes: Number(formData.durationMinutes),
        endTime: formData.endTime,

        maxCapacity: Number(formData.maxCapacity),
        enrolledCount: formData.enrolledCount,

        // Datas de calendário: string "YYYY-MM-DD" (contrato oficial)
        startDate: formData.startDate,
        endDate: formData.endDate,

        // Auditoria: Timestamp do Firestore (contrato oficial)
        updatedAt: Timestamp.now(),
        updatedBy: {
            uid: authUser?.uid || "",
            email: authUser?.email || "",
            name: authUser?.displayName || authUser?.name || ""
        },
        // Preserva createdAt/createdBy no update; cria novos no insert
        ...(formData.id ? {} : {
            createdAt: Timestamp.now(),
            createdBy: {
                uid: authUser?.uid || "",
                email: authUser?.email || "",
                name: authUser?.displayName || authUser?.name || ""
            }
        })
    };

    Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);
    return payload;
};
